<template>
  <div>
    <v-btn class="btn-add-category" @click="resetAccountCard(true)">
      <img src="@/assets/img/plus-icon.png" alt="icon">
      <slot></slot>
      {{ $t('Создать карточку') }}
    </v-btn>
    <v-dialog v-model="accountCardDialog" max-width="600">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Создание карточки') }}
          <v-btn color="modal-close" @click.native="resetAccountCard(false)">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="files">
            <v-row>
              <v-col cols="12" sm="12" class="col-file-input">
                <div class="select-def">
                  <v-select
                    v-model="reportId"
                    :items="reports"
                    item-text="transName"
                    item-value="id"
                    :placeholder="$t('Выберите форму отчета')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="12">
                <v-btn color="primary" dark @click="createAccountCard">
                  {{ $t('Создать') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AnimalAccounting from '@/model/animalAccounting'
import Report from '@/model/report'
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    reports: [],
    accountCardDialog: false,
    reportId: null
  }),
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // Обновление формы для создания
    resetAccountCard (flag) {
      this.accountCardDialog = flag
      this.reportId = null
    },
    fetchData () {
      Report.formReports().then((response) => {
        this.reports = response.data.reports
      }).catch((error) => {
        console.log(error)
      })
    },
    // Создание учета карточки
    createAccountCard () {
      if (!this.reportId) {
        this.$noty.error(this.$i18n.t('Выберите форму отчета'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }
      this.setLoading(true)
      this.accountCardDialog = false
      AnimalAccounting.preCreate(this.reportId)
        .then((response) => {
          if (response.status === 201) {
            const { id, reportId } = response.data
            this.$router.push({
              name: 'account-card',
              params: { id: id, rId: reportId }
            })
          }
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
